const $inject = [];

const lbaGridItem = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaGridItemCtrl',
    controllerAs: 'vm',
    template: require('./lbaGridItem.html'),
    // link: function (scope, element, attrs, ctrls) {
    //   scope.vm.grid = ctrls;
    // }
  }
};

lbaGridItem.$inject = $inject;

export default lbaGridItem;



// WEBPACK FOOTER //
// ./src/components/lbaGridItem/lbaGridItemDir.js